module.exports = __webpack_public_path__ + "media/images/talent/lp/profile02_sp-7ad367af4543c933574abddf4c370bd2.png";